export default {
  header: 'We moeten je telefoonnummer verifiëren',
  remember_device: {
    label: 'Onthoud dit apparaat gedurende {{days}} dagen',
  },
  buttons: {
    confirm: 'Bevestigen',
  },
  toasts: {
    invalid_code: 'Ongeldige code. Probeer het opnieuw.',
  },
};
